<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>

        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card style="border-radius: 1.5em;" >
            <div slot="header">
              <h3 class="card-title mb-0">Información de filtro</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId"/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de inicio</label>
                <vs-input type="date" v-model="initialDate" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha de fin</label>
                <vs-input type="date" v-model="finalDate" class="w-100 "/>
              </vs-col>
            </vs-row>
            <br/>
            <vs-row>
              <!-- Selector de productos -->
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereProducts">
                <label class="vs-input--label">Clase de producto</label>
                <multiselect v-model="selectedProducts" placeholder="Seleccione productos" label="name"
                             ref="myMultiselect" track-by="code" :options="showProductList" :multiple="true"
                             :taggable="true" :searchable="false" :max-height="150">
                </multiselect>
              </vs-col>

              <!-- Selector de detallado-->
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereProducts">
                <label class="vs-input--label">Productos</label>
                <div class="d-flex is-align-items-stretch">
                  <vs-checkbox v-model="detail">Detallado</vs-checkbox>
                </div>
              </vs-col>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button :disabled="!isSearch" @click="listPreviewProduct()">Buscar</vs-button>
                <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button :disabled="!isDownloadable" class="btnx" type="filled" color="danger"
                               @click="downloadReport()">
                      <i class="ti-upload mr-2"></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                   :value="document.id" :key="document.id"
                                   :id="document.id" @click="formatType=document.id">{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>
        <vs-col vs-lg="12" vs-xs="12" v-if="showTable">
          <vs-card style="border-radius: 1.5em;">
            <h3 class="card-title d-flex">
              Tabla de previsualización
            </h3>
            <div class="border" v-if="detail" :key="forceRender" style="max-height: 43em;
              overflow-y: auto;">
              <vs-table max-items="50" pagination :data="tableData">
                <template slot="thead">
                  <vs-th>Fecha liquidación</vs-th>
                  <vs-th>Nombre del producto</vs-th>
                  <vs-th>Cantidad</vs-th>
                  <vs-th>Subtotal</vs-th>
                  <vs-th>Impuesto</vs-th>
                  <vs-th>Total</vs-th>
                  <vs-th>Factura</vs-th>
                  <vs-th>Prefijo</vs-th>
                  <vs-th>Usuario liquidación</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].billDate">
                      {{ data[indextr].billDate }}
                    </vs-td>
                    <vs-td :data="data[indextr].productName">
                      {{ data[indextr].productName }}
                    </vs-td>
                    <vs-td :data="data[indextr].quantity">
                      {{ data[indextr].quantity }}
                    </vs-td>
                    <vs-td :data="data[indextr].subtotal">
                      {{ data[indextr].subtotal }}
                    </vs-td>
                    <vs-td :data="data[indextr].tax">
                      {{ data[indextr].tax }}
                    </vs-td>
                    <vs-td :data="data[indextr].productTotal">
                      {{ data[indextr].productTotal }}
                    </vs-td>
                    <vs-td :data="data[indextr].billNumber">
                      {{ data[indextr].billNumber }}
                    </vs-td>
                    <vs-td :data="data[indextr].prefix">
                      {{ data[indextr].prefix }}
                    </vs-td>
                    <vs-td :data="data[indextr].userBill">
                      {{ data[indextr].userBill }}

                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
            <div class="border" v-if="!detail" :key="forceRender" style="max-height: 43em;
              overflow-y: auto;">
              <vs-table max-items="50" pagination :data="tableData">
                <template slot="thead">
                  <vs-th>Nombre del producto</vs-th>
                  <vs-th>Cantidad</vs-th>
                  <vs-th>Subtotal</vs-th>
                  <vs-th>Impuesto</vs-th>
                  <vs-th>Total facturado</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].productName">
                      {{ data[indextr].productName }}
                    </vs-td>
                    <vs-td :data="data[indextr].quantity">
                      {{ data[indextr].quantity }}
                    </vs-td>
                    <vs-td :data="data[indextr].subtotal">
                      {{ data[indextr].subtotal }}
                    </vs-td>
                    <vs-td :data="data[indextr].tax">
                      {{ data[indextr].tax }}
                    </vs-td>
                    <vs-td :data="data[indextr].productTotal">
                      {{ data[indextr].productTotal }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>
<script>
import Multiselect from "vue-multiselect";
import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import parkingReportsEndpoints from "@/endpoints/reports/parking-reports/parkingReportsEndpoints";
import conceptEndpoint from "@/endpoints/billing/ConceptEndpoint";
import {ROUTES} from "@/global/api_routes";
import DateUtils from "../../../../global/DateUtils";
import toast from "@/global/ToastConfig";

export default {
  name: "product-report",
  components: {
    CompanySelector,
    Multiselect
  },
  data() {
    return {
      tableDataSummary: [],
      tableDataDetail: [],
      detail: false,
      thereProducts: false,
      thereDetail: false,
      companyId: null,
      initialDate: null,
      finalDate: null,
      formatType: "xlsx",
      isLoading: false,
      discount: null,
      showProductList: [],
      selectedProducts: [],
      documents: [
        {name: "Excel", id: "xlsx"},
        {name: "Pdf", id: "pdf"},
      ],
      tableData: [],
      isDownloadable: false,
      isSearch: false,
      ignorePagination: true,
      showTable: false,
      forceRender: 0,
      page: 1,
      perPage: 50,
      total: 0,
    }
  },
  watch: {
    companyId() {
      this.showTable = false;
      this.tableData = [];
      this.showProductList = [];
      this.selectedStations = [];
      this.selectedMethods = [];
      this.initialDate = null;
      this.finalDate = null;
      this.validateParams();
    },
    initialDate() {
      this.selectedProducts = [];
      this.showProductList = [];
      this.showTable = false;
      this.tableData = [];
      this.validateParams();
    },
    finalDate() {
      this.selectedProducts = [];
      this.showProductList = [];
      this.showTable = false;
      this.tableData = [];
      this.validateParams();
    },
    selectedProducts() {
      this.showTable = false;
      this.tableData = [];
    },
    showProductList() {
      this.thereProducts = this.showProductList.length > 0;
    },
    detail() {
      this.showTable = false;
      this.tableData = [];
    }
  },
  methods: {
    /**
     *
     * @returns {Promise<void>}
     */
    validateParams() {
      this.isLoading = true;
      if (!this.companyId) {
        this.thereProducts = false;
        this.isLoading = false;
        return;
      }
      if (!this.finalDate || !this.initialDate) {
        this.thereProducts = false;
        this.isLoading = false;
        return;
      }
      this.listProduct();
    },
    /**
     *
     */
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
      this.showTable = false;
      this.tableData = [];
      this.thereProducts = false;
      this.selectedProducts = [];
      this.isSearch = false;
      this.isDownloadable = false;
    },
    /**
     *
     * @returns {string}
     */
    getValidateProducts() {
      return this.selectedProducts.length === 0
          ? this.showProductList.map(item => item.code).join(",")
          : this.selectedProducts.map(item => item.code).join(",")
    },
    /**
     *
     * @returns {{typeProduct: string, finalDate: string, companyId: null, detail: boolean, type: string, initialDate: string}}
     */
    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
        }),
        finalDate: DateUtils.toDateShortString({
          date: this.finalDate,
        }),
        type: this.formatType,
        detail: this.detail,
        typeProduct: this.getValidateProducts(),
      };
    },
    /**
     *
     * @returns {Promise<void>}
     */
    validateForm() {
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar fecha inicial y/o fecha final");
      }
      const validationResult = this.$validator.validateAll();
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        throw new Error("Fecha final no puede ser inferior a fecha inicial");
      }
      if (!validationResult) {
        throw new Error("Complete el formulario");
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañía");
      }
    },
    /**
     *
     * @returns {Promise<void>}
     */
    listProduct() {
      try {
        this.showProductList = [];
        this.validateForm();
        const params = this.prepareParameters();
        conceptEndpoint.listByProduct(params)
            .then(data => {
              if (data.length === 0) {
                this.isLoading = false;
                this.thereProducts = false;
                this.isSearch = false;
                this.isDownloadable = false;
                return;
              }
              data.forEach((product) => {
                const products = {
                  name: product.title,
                  code: product.code,
                };
                this.showProductList.push(products);
              });
              this.isSearch = true;
              this.isDownloadable = true;
              this.isLoading = false;
              this.thereProducts = true;
            });
        this.forceRender++;
      } catch (error) {
        toast.error(error);
      }
    },
    /**
     *
     * @returns {Promise<void>}
     */
    listPreviewProduct() {
      try {
        this.validateForm();
        this.isLoading = true;
        this.tableData = [];
        const objParams = this.prepareParameters();
        parkingReportsEndpoints.listProducts(objParams)
            .then(info => {
              if (info.length === 0) {
                this.tableData = [];
                this.isLoading = false;
                return;
              }
              this.isLoading = false;
              this.tableData = info;
              console.log(info);
              this.showTable = true;
            });
      } catch (error) {
        toast.error(error);
      }
    },
    /**
     *
     * @returns {Promise<void>}
     */
    downloadReport() {
      try {
        this.validateForm();
        this.isLoading = true;
        const objParams = this.prepareParameters();
        parkingReportsEndpoints.downloadProducts(objParams)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              this.isLoading = false;
              let a = document.createElement("a");
              const urlFile =
                  process.env.VUE_APP_URL + ROUTES.GLOBAL.DOWNLOAD_FILE + data.info;
              a.href = urlFile;
              document.body.appendChild(a);
              console.log(urlFile);
              a.download = urlFile;
              a.click();
            });
      } catch (error) {
        toast.error(error);
      }

    }
  }
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>
